export const STORYBOOK_RUNTIME = !!import.meta.env.STORYBOOK_RUNTIME;
